import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(0, 0, 3)
  },
  header: {
    marginBottom: spacing(3)
  },
  stepContainer: {
    padding: spacing(4),
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 4
  },
  fieldGroup: {
    marginTop: spacing(3)
  },
  processingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing(6),
    gap: spacing(2)
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spacing(2),
    padding: spacing(4)
  },
  scormCompletedBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing(2),
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    marginTop: spacing(2)
  }
}))
